<template>
    <hts-modal
        v-model="cVisible"
        size="large"
        title="Xác nhận thông tin điều phối chính thức">
        <hts-loading :loading="loading">
            <div>
                <template v-if="scheduleData && scheduleData.length">
                    <div>
                        <p>
                            Danh sách chặng cần điều phối:
                        </p>
                        <journey-list
                            v-model:selected="selectedJourneys"
                            class="max-h-[400px]"
                            :items="scheduleData"
                            attribute-key="journey"
                            :disable-function="disableCheck"
                            extend-class="grid grid-cols-3">
                            <template #extend="{ item }">
                                <div v-if="item.completed">
                                    <div>
                                        <label class="mr-1">
                                            Đã được điều phối cho xe:
                                        </label>
                                        <span class="font-bold text-2xl">
                                            {{ item.vehicle?.licensePlate }}
                                        </span>
                                    </div>
                                </div>
                                <div
                                    v-else
                                    class="col-span-2">
                                    <template v-if="item.vehicle?.licensePlate">
                                        <div>
                                            <label class="mr-1">
                                                Xe được điều phối:
                                            </label>
                                            <span class="font-bold text-2xl">
                                                {{ item.vehicle?.licensePlate }}
                                            </span>
                                        </div>
                                        <template v-if="Array.isArray(item.detachJourneys) && item.detachJourneys.length">
                                            <div>
                                                <span class="mr-1 inline-flex align-middle">
                                                    Đổi
                                                </span>
                                                <journey-detach-card :journeys="item.detachJourneys" />
                                            </div>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <span class="text-error-500 font-bold text-lg">
                                                Không tìm được xe phù hợp
                                            </span>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </journey-list>
                    </div>
                    <hts-form-button
                        :disabled="!selected"
                        class="mt-4"
                        color="primary"
                        :loading="updating"
                        @click="confirm">
                        {{ 'Xác nhận điều phối' }}
                    </hts-form-button>
                </template>
                <template v-else>
                    <div>
                        <p>
                            Điều phối hoàn tất hoặc không có chặng cần điều phối.
                        </p>
                    </div>
                </template>
            </div>
        </hts-loading>
    </hts-modal>
</template>
<script lang="ts" setup>
import JourneyList from './journey-list.vue'
import JourneyDetachCard from './journey-detach-card.vue'
const store = $store()
const emits = defineEmits(['change'])
const loading = ref(true)
const updating = ref(false)
const cVisible = ref(false)
const currentSchedule = reactive({
  _id: null,
  journeys: [],
  nextJourney: {},
  completed: false
})
const scheduleData = ref([])
const selectedJourneys = ref<any[]>([])
const selected = computed(() => selectedJourneys.value.length > 0)
const tempIds = ref<any[]>([])

const refresh = $lodash.debounce(() => {
  getCurrentSchedule(tempIds.value)
}, 500)

const getCurrentSchedule = (ids: any[]) => {
  const params: any = {}
  if (Array.isArray(ids) && ids.length) {
    tempIds.value = ids
    params.body = { ids }
  }
  loading.value = true
  $api($url.journey.schedule.get, params).then(({ data }) => {
    const temp = (data?.value || {}).data || {}
    Object.assign(currentSchedule, temp.currentSchedule || {})
    scheduleData.value = temp.scheduleData || []
    if (!Array.isArray(scheduleData.value) || !scheduleData.value.length) {
      hideAlert()
    }
    loading.value = false
  })
}

const needScheduleJourneyCount = computed<number>(() => scheduleData.value.filter((s: any) => !!s.vehicle).length)

const confirm = () => {
  updating.value = true
  $api($url.journey.schedule.confirm, { uriParams: { ID: currentSchedule._id }, body: { ids: selectedJourneys.value } })
    .then(({ success, data }) => {
      const temp = (data?.value || {}).data || {}
      const tempScheduleData = temp.scheduleData || []
      const tempJourneys = tempScheduleData
        .filter(({ journey, vehicle }: any) => {
          return !!vehicle && selectedJourneys.value.includes(journey._id)
        })
        .map(({ journey, vehicle }: any) => {
          Object.assign(journey, {
            vehicleId: vehicle._id,
            rowId: vehicle._id
          })
          return journey
        })
      selectedJourneys.value.forEach((j: any) => {
        const existsIndex = tempIds.value.findIndex((t: any) => t === j)
        if (existsIndex >= 0) {
          tempIds.value.splice(existsIndex, 1)
        }
      })
      nextTick(() => {
        if (selectedJourneys.value.length === needScheduleJourneyCount.value) {
          emits('change', tempJourneys)
          hide()
        } else {
          refresh()
          emits('change', tempJourneys)
        }
        hideAlert()
        updating.value = false
      })
    })
    .catch((e: any) => {
      updating.value = false
    })
}

const hideAlert = () => {
  store.systemAlert.setAlertVisible(false)
  store.systemAlert.setAlertOptions({ scheduleCompleted: true })
}

const disableCheck = ({ vehicle }: any) => {
  return !vehicle
}

const show = (ids: any[]) => {
  Object.assign(currentSchedule, {
    _id: null,
    journeys: [],
    nextJourney: {},
    completed: false
  })
  selectedJourneys.value = []
  scheduleData.value = []
  cVisible.value = true
  getCurrentSchedule(ids)
}

const hide = () => {
  nextTick(() => {
    cVisible.value = false
  })
}
defineExpose({ show, hide })
</script>
